"use client";
import React from "react";
import DOMPurify from "@/app/[lang]/utils/dompurify";

// Components
import Link from "next/link";
import Image from "next/image";
import { Divider, Text } from "@/app/[lang]/components/ui/AntdLite";

import { Arrow } from "../ui/Arrow";
import {formatDate, getSafeHeading, getStrapiMedia} from "@/app/[lang]/utils/api-helpers";

import styles from './Article.module.scss';
import type { ArticleProps } from "../Article/interface";



const Article:React.FC<ArticleProps> = ( props ) => {
  const { article } = props;
  const { title, description, createdAt, publish_date, thumbnail, slug, category, hidePublishedDate, headingLevel } = article.attributes;
  const thumbnailData = thumbnail?.data?.attributes ?? thumbnail;
  const categoryData = category?.data?.attributes ?? category;

  const URL = `/${categoryData?.slug}/${slug}`;

  const imgSrc = getStrapiMedia(thumbnailData?.url) || "";
  const plainTitle = (title || "").replace(/<[^>]*>/g, "").trim();
  const TitleTag = getSafeHeading(headingLevel, "h3");

  return (
    <section className={ styles.article }>
      { thumbnailData?.url &&
        <a href={URL} className={ styles.thumbnailLink }>
          <Image
            alt={ thumbnailData?.alternativeText || "PPC Blue Romania"}
            src={ imgSrc }
            width={675}
            height={420}
            sizes="(max-width: 768px) 212px, 675px"
            loading="lazy"
            decoding="async"
            className={ styles.thumbnail }
          />
        </a>
      }

      <section className={ styles.content }>
        <TitleTag className={ styles.title } dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(title) }} />

        { !hidePublishedDate ?
          <Text className={styles.date}>
              {formatDate(publish_date ?? createdAt)}
          </Text> : null
        }

        { ! imgSrc && (
          <>
            <Divider />
            <Text>{description}</Text>
          </>
        ) }
      </section>

      <div className={styles.articleButtonWrapper}>
        <Link
          href={URL}
          className={styles.articleButton}
          aria-label={plainTitle || "PPC Blue Romania"}
        >
          <Arrow />
        </Link>
      </div>
    </section>
  );
}

export default Article;
